export const ALREADY_HAS_ACTIVE_ACCOUNT = 'ALREADY_HAS_ACTIVE_ACCOUNT';

export const alreadyHasActiveAccount = payload => dispatch =>
  dispatch({
    type: ALREADY_HAS_ACTIVE_ACCOUNT,
    payload,
  });
